import { useState } from 'react'
import { createPortal } from 'react-dom'
import styled from '@emotion/styled'
import { X } from 'components/icons'
import { CvvRegex } from './Checkout.utils'
import { Input } from 'components'

const CvvModalOverlay = styled.div`
  position: fixed;
  z-index: 200;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
`

const CvvModalContainer = styled.div`
  position: relative;
  width: 40rem;
  max-width: 90%;
  background-color: ${(props) => props.theme.bgColors.primary};
  border-radius: 8px;
  padding: 2rem;
`

const CvvModalTitle = styled.h2`
  font-size: ${(props) => props.theme.fonts.sizes.xBig};
  margin: 0 0 1.5rem;
  text-transform: capitalize;
`

const CvvModalError = styled.div`
  font-size: ${(props) => props.theme.fonts.sizes.small};
  margin-top: 4px;
`

const CvvModalActions = styled.div`
  display: flex;
  padding-top: 16px;
`

const CvvModalConfirmButton = styled.button`
  flex: 1;
  padding: 1rem;
  background-color: ${(props) => props.theme.buttons.colors.primary.bgColor};
  color: ${(props) => props.theme.buttons.colors.primary.color};
  border-radius: ${(props) => props.theme.buttons.sizes.small.borderRadius};
  font-size: ${(props) => props.theme.fonts.sizes.small};
  font-weight: bold;
`

const CvvModalCloseButton = styled.button`
  position: absolute;
  top: 1rem;
  right: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${(props) => props.theme.links.dark.color};

  &:hover,
  &:active,
  &:focus {
    color: ${(props) => props.theme.links.dark.hover};
  }
`

const CheckoutCvvModal = ({
  onConfirm,
  onClose,
}: {
  onConfirm: (cvv: string) => void
  onClose: () => void
}) => {
  const [cvv, setCvv] = useState('')
  const [cvvError, setCvvError] = useState(false)

  const handleConfirm = () => {
    const valid = CvvRegex.test(cvv)
    if (!valid) {
      setCvvError(true)
      return
    }
    onConfirm(cvv)
  }

  return createPortal(
    <CvvModalOverlay onClick={onClose}>
      <CvvModalContainer onClick={(e) => e.stopPropagation()}>
        <CvvModalCloseButton onClick={onClose} aria-label="Close">
          <X size={20} />
        </CvvModalCloseButton>
        <CvvModalTitle>Confirm CVV</CvvModalTitle>
        <Input
          name="cvv"
          type="number"
          value={cvv}
          placeholder="CVV Number"
          autoFocus
          onChange={(e) => {
            const val = e.target.value
            if (val.length > 4) return
            setCvv(val)
            setCvvError(false)
          }}
          style={{ margin: 0 }}
        />
        {cvvError && (
          <CvvModalError>Please enter a valid CVV number</CvvModalError>
        )}
        <CvvModalActions>
          <CvvModalConfirmButton onClick={handleConfirm}>
            Confirm CVV
          </CvvModalConfirmButton>
        </CvvModalActions>
      </CvvModalContainer>
    </CvvModalOverlay>,
    document.body
  )
}

export default CheckoutCvvModal
